<div class="col mt-2 p-0">
    <form [formGroup]="myGroup">
        <h5 class="section-head my-4">{{'WEBKESS_INTEGRATION.SETTINGS' | translate }}</h5>
        <div class="mx-4">
            <!-- <h3 class="section-title-new section-head mt-4 mb-2">{{'HAND-KISS surveillance' | translate }}</h3> -->
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="col-sm-12 col-md-6 p-0 form-group d-flex align-item-center justify-content-between">
                        <label for="timeIntervel">
                            <div class="section-title">{{'WEBKESS_INTEGRATION.TIME_INTERVAL' | translate }}</div>
                            {{'WEBKESS_INTEGRATION.ONE_UP_TO_24_HOURS' | translate }}
                        </label>
                        <div class="col-auto">
                            <input class="form-control" type="text" name="timeIntervel" min="1" max="24"
                                formControlName="timeIntervel" [validation]="true" mask="00"
                                (keypress)="numberOnly($event)">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col my-4">
                <button (click)="saveConfigDetails(template)" class="btn btn-primary mr-4">{{(generalSettingID ==
                    0)?translationKeys.Authorization.Save: translationKeys.Observation.Update | translate }}</button>
                <!-- <button class="btn btn-secondary">{{'Cancel' | translate }}</button> -->
            </div>
        </div>
    </form>

</div>
<!-- Modal - Add User Confirmation -->
<ng-template #template class="modal-confirm">
    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{'WEBKESS_INTEGRATION.CONFIRMATION' | translate}}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body text-center" data-simplebar>
        <p *ngIf="generalSettingID == 0">{{'CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.CONFIG_DETAILS' |
            translate}}</p>
        <p *ngIf="generalSettingID != 0">{{'CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.CONFIG_DETAILS'
            | translate}}</p>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-6 my-3">
                    <a class="btn btn-continue-bordered-bd" data-dismiss="modal"
                        (click)="modalRef.hide();">{{translationKeys.Authorization.Done | translate
                        }}</a>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #templateInstitution>
    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title" id="exampleModalLabel">{{ translationKeys.UserProfiles.SelectInsititutions | translate}}</h5>
        <a class="cursor" aria-label="Close" (click)="modalRef.hide()"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar class="change-lang">
        <div [formGroup]="myInstitutions" class="col-12">
            <div class="mb-2 form-check" *ngFor='let Institutions of InstitutionsList;let i = index'>
                <input type="radio" [value]="Institutions.institution.institutionID" name="selectedIns"
                    *ngIf="showInstitutionDropDown()" formControlName="selectedIns" class="form-check-input"
                    id={{Institutions.institution.institutionID}}>
                <label class="form-check-label"
                    for={{Institutions.institution.institutionID}}>{{Institutions.institution.institutionName | labelSanitizer}}</label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-6 my-3">
                    <button type="button" class="btn btn-block btn-primary"
                        (click)="onInstitutionChange(myInstitutions.value.selectedIns);modalRef.hide();">{{
                        translationKeys.Authorization.Done | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>